import { $, $$ } from '../../../shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';

const navAnchors = $$('.nav-anchors');
const accordionInstances = [];

const accordionHandler = nav => {
  const handler = $('.nav-anchors__button', nav);
  const target = $('.nav-anchors__content', nav);
  const targetInner = target ? $('.nav-anchors__content-inner', target) : false;

  if (!handler || !target || !targetInner) return;

  const accordionInstance = new Accordion({
    handler,
    target,
    targetInner,
    initOpened: true,
  });

  accordionInstances.push(accordionInstance);
  accordionInstance.init();
};

const focusHandler = nav => {
  // Ensure anchor target is focusable
  const anchorLinks = nav.querySelectorAll('.styled-link--anchor');
  const anchorClickHandler = e => {
    const link = e?.target;
    const anchorTargetSelector = link?.getAttribute('href');
    const anchorTarget = document.querySelector(anchorTargetSelector);
    const originalTabindex = anchorTarget?.tabindex || '';
    const resetFocusHandling = () => {
      originalTabindex
        ? anchorTarget.setAttribute('tabindex', originalTabindex)
        : anchorTarget.removeAttribute('tabindex');

      anchorTarget.removeEventListener('blur', resetFocusHandling);
    };

    if (!anchorTargetSelector) return;
    if (!anchorTarget) return;

    anchorTarget.addEventListener('blur', resetFocusHandling);
    anchorTarget.setAttribute('tabindex', -1);
    anchorTarget.focus();
  };

  anchorLinks.forEach(link => {
    link.addEventListener('click', anchorClickHandler);
  });
};

navAnchors.forEach(nav => {
  accordionHandler(nav);
  focusHandler(nav);
});
